import { Component, OnInit, HostListener } from '@angular/core';

import { SharedService } from '@shared/services/shared.service';
import { TrackingService } from '@shared/services/tracking.service';
import { MOBILE_VIEW_TRESHOLD, MOBILE_APP } from 'src/app/app.constants';

@Component({
  selector: 'app-mobile-promo',
  templateUrl: './mobile-promo.component.html',
  styleUrls: ['./mobile-promo.component.scss'],
  standalone: false
})
export class MobilePromoComponent implements OnInit {
  isMobile: boolean;

  constructor(
    private trackingService: TrackingService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.isMobile = this.checkMobileScreen(window.innerWidth);
  }

  checkMobileScreen(screen: number): boolean {
    if (screen > MOBILE_VIEW_TRESHOLD) {
      return false;
    } else {
      setTimeout(() => {
        if (document.getElementById('launcher')) {
          document.getElementById('launcher').setAttribute('class', 'lower');
        }
      }, 1000);
      return true;
    }
  }

  goTo(store: string): void {
    this.trackingService.trackActivity(`[Button] Get app from ${store}`);
    window.open(store === 'app_store' ? MOBILE_APP.appStore : MOBILE_APP.playStore, '_blank');
  }

  goToDeepLink() {
    this.trackingService.trackActivity('[Button] Open app from mobile promotion banner');
    window.open(MOBILE_APP.nativeApp);
    this.close();
  }

  close(activity?: string): void {
    this.sharedService.expireMobilePromo(30);

    if (activity) {
      this.trackingService.trackActivity(activity);
    }

    if (document.getElementById('launcher')) {
      document.getElementById('launcher').classList.remove('lower');
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: Window }): void {
    this.isMobile = this.checkMobileScreen(event.target.innerWidth);
  }
}
